const DISCLOSURE_DROPDOWN_ITEM_NAME = 'GlDisclosureDropdownItem';
const DISCLOSURE_DROPDOWN_GROUP_NAME = 'GlDisclosureDropdownGroup';
const DISCLOSURE_DROPDOWN_GROUP_BORDER_POSITIONS = {
  top: 'top',
  bottom: 'bottom'
};

export { DISCLOSURE_DROPDOWN_GROUP_BORDER_POSITIONS, DISCLOSURE_DROPDOWN_GROUP_NAME, DISCLOSURE_DROPDOWN_ITEM_NAME };
